import { useState, useCallback } from "react";
import { Button, Typography } from "@volvo/vcdk-react";
import styles from "./FloatingSupportButton.module.css";
import SupportForm from "../SupportForm/SupportForm";

const BRANDS = [
    { code: "RT", label: "Renault Trucks" },
    { code: "VB", label: "Volvo Buses" },
    { code: "VT", label: "Volvo Trucks" },
    { code: "VE", label: "Volvo Energy" },
] as const;

const FloatingSupportButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState<string | null>(null);

    const handleOpen = useCallback(() => {
        setIsOpen(true);
        setIsClosing(false);
        setSelectedBrand(null);
    }, []);

    const handleClose = useCallback(() => {
        setIsClosing(true);
        setTimeout(() => {
            setIsOpen(false);
            setIsClosing(false);
            setSelectedBrand(null);
        }, 250);
    }, []);

    const handleBrandSelect = useCallback((brandCode: string) => {
        setSelectedBrand(brandCode);
    }, []);

    const handleBack = useCallback(() => {
        setSelectedBrand(null);
    }, []);

    if (!isOpen) {
        return (
            <div className={styles.floatingButtonWrapper}>
                <Button
                    variant="primary"
                    size="large"
                    iconStart="chat"
                    aria-label="Open support form"
                    onClick={handleOpen}
                >
                    Support
                </Button>
            </div>
        );
    }

    return (
        <>
            <div className={styles.overlay} onClick={handleClose} />
            <div
                className={`${styles.panel} ${isClosing ? styles.panelClosing : ""}`}
            >
                <div className={styles.panelHeader}>
                    <div className={styles.panelHeaderLeft}>
                        {selectedBrand && (
                            <button
                                className={styles.backButton}
                                onClick={handleBack}
                                aria-label="Go back to brand selection"
                            >
                                ←
                            </button>
                        )}
                        <Typography variant="subtitle1">
                            {selectedBrand
                                ? `Support - ${BRANDS.find((b) => b.code === selectedBrand)?.label}`
                                : "Contact Support"}
                        </Typography>
                    </div>
                    <button
                        className={styles.closeButton}
                        onClick={handleClose}
                        aria-label="Close support panel"
                    >
                        ×
                    </button>
                </div>
                <div className={styles.panelBody}>
                    {!selectedBrand ? (
                        <div
                            className={`${styles.brandSelection} ${styles.stepContent}`}
                        >
                            <div className={styles.brandSelectionTitle}>
                                Which brand would you like to contact?
                            </div>
                            {BRANDS.map((brand) => (
                                <button
                                    key={brand.code}
                                    className={styles.brandOption}
                                    onClick={() =>
                                        handleBrandSelect(brand.code)
                                    }
                                >
                                    {brand.label}
                                    <span className={styles.brandArrow}>→</span>
                                </button>
                            ))}
                        </div>
                    ) : (
                        <div className={styles.stepContent}>
                            <SupportForm
                                brand={selectedBrand}
                                onClose={handleClose}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default FloatingSupportButton;
